
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 32 28","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"32","height":"28","data-name":"Vector Smart Object","xlink:href":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAcCAQAAACqy3WpAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfkBwcLGDGxZmAfAAABwklEQVQ4y6WVsUsbYRjGnztTSDBasEMFtV2EoGBwa4+6OLWJ4B9QqIPQUTsE4mTARaSIgrNLhw79B0pwETeXQppFg6DSkESIGtG2hgTy65BErF6u99nvXV6e757fdwfv851Qq0bZBQ6J3Si+qt1Y7POZUZJUefEQwBDwFCGWKdBvDgjxi2mE6CLNDo9MASLBKc8Roo9DNswBFl/4RgghovzmnSlAdJPlU6t/yzXjpgAxTIW5Vr/OMU9MASJGlQmECLDNFl3/Alig/1oBSXHt3VIsDehCPyVJjxVWwcM9oq8BldTQ8V/yke/jIyrZyin64PePKmexovfK39sKalC2pLIqHoBBbVq81I4+qHpvM6QhnenMwx7UuiabOZw3i3Cr5tjHEmKGE3qN7T0UmWkOkk2WVWPAR7LY7Ul0qBM3sr+hjnN7lBNUGPNtH+OcxN0srFHmlS+7Q5k1tzClqLGA7Wm2SVIj1SmNUxT5Thyrgz1GhiJTXnEOs8QVByziELxRgzgscsAVS4S974MmZJY0l9TJkyFDnjqXpJm9a27eB50G1VZEA+qTdK6Ccmq4P+YOeCbbRW3oh4vq8gmv6bRcfnt/AFK18Dbq/T+kAAAAAElFTkSuQmCC"}})])
          )
        }
      }
    